import Cookies from 'js-cookie';
import apiSlice from './apiSlice';

const apiSliceWithTag = apiSlice.enhanceEndpoints({ addTagTypes: ['Favorites'] });

const apiFavoritesSlice = apiSliceWithTag.injectEndpoints({
  endpoints: (builder) => ({
    listFavorites: builder.query({
      query: ({ eans, psize, page }) => ({
        url: `/community/favorites/`,
        params: {
          eans,
          psize,
          page,
        },
      }),
      providesTags: ['Favorites'],
    }),
    getFavorite: builder.query({
      query: (ean) => `/community/products/${ean}/favorites/`,
      providesTags: ['Favorites'],
    }),
    handleFavorite: builder.mutation({
      query: ({ ean, favorite }) => ({
        url: `/community/products/${ean}/favorites/`,
        method: 'PATCH',
        body: { favorite },
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: ['Favorites'],
    }),
  }),
});

export const { useListFavoritesQuery, useLazyListFavoritesQuery, useGetFavoriteQuery, useHandleFavoriteMutation } = apiFavoritesSlice;

export default apiFavoritesSlice;
